import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { HeadingModel } from "../model/heading-widget.model";
import { HeadingWidgetService } from "../service/heading-widget.service";
import { CommonModule } from "@angular/common";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";

@Component({
  selector: "rfc-title-widget",
  templateUrl: "./title-widget.component.html",
  styleUrls: ["./title-widget.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    I18nPipe
  ]
})
export class TitleWidgetComponent {
  @Input() titleWidget: HeadingModel;
  constructor(private headingWidgetService: HeadingWidgetService) {}

  getTitle(): string {
    const strConvertetFromCamelToSnake =
      this.headingWidgetService.camelToUnderscore(this.titleWidget?.name);
    return `${strConvertetFromCamelToSnake}_title`;
  }

  getSubtitle(): string {
    return this.titleWidget?.subTitle ?? "";
  }
}
